module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-02.a002977.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-02.jpg
// module id = s8Li
// module chunks = 52